import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22c5b9b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "section-input" }
const _hoisted_3 = { class: "input-part" }
const _hoisted_4 = { class: "bottom-btn-wrapper" }
const _hoisted_5 = { class: "two-btn-block" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-pay" }, "5G, 3G, LTE 환경에서 데이터 요금이 발생됩니다.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_logo = _resolveComponent("header-logo")!
  const _component_board_marquee = _resolveComponent("board-marquee")!
  const _component_autocall_text_input = _resolveComponent("autocall-text-input")!
  const _component_autocall_input_car = _resolveComponent("autocall-input-car")!
  const _component_autocall_button_cert = _resolveComponent("autocall-button-cert")!
  const _component_button_icon = _resolveComponent("button-icon")!
  const _component_button_big = _resolveComponent("button-big")!
  const _component_autocall_button_off = _resolveComponent("autocall-button-off")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_header_logo),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_board_marquee),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_autocall_text_input, { class: "text" }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_autocall_input_car, { disabled: _ctx.isCarChecked }, null, 8, ["disabled"]),
          _withDirectives(_createVNode(_component_autocall_button_cert, { class: "btn-cert" }, null, 512), [
            [_vShow, !_ctx.isCarChecked]
          ])
        ]),
        (_ctx.hashistory === 'y' && !_ctx.isCarChecked)
          ? (_openBlock(), _createBlock(_component_button_icon, {
              key: 0,
              command: "callLastHistory",
              icon: "icon-arrow-back.png",
              text: "마지막 호출 내역",
              class: "btn-icon-border __reverse recert"
            }))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_button_icon, {
          command: "clearCarCheck",
          icon: "icon-arrow-back.png",
          text: "차량번호 재입력",
          class: "btn-icon-border recert"
        }, null, 512), [
          [_vShow, _ctx.isCarChecked]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createVNode(_component_button_big, {
            command: "callDirect",
            disabled: !_ctx.isCarChecked,
            title: "운전자 다이렉트 호출",
            subTitle: "오토콜이 운전자를 대신 호출합니다"
          }, null, 8, ["disabled"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_button_icon, {
              command: "sendMessage",
              disabled: !_ctx.isCarChecked,
              icon: "icon-message.png",
              text: "메시지 보내기",
              class: "btn-icon-radius left shadow"
            }, null, 8, ["disabled"]),
            _createVNode(_component_button_icon, {
              command: "confirmCall",
              disabled: !_ctx.isCarChecked,
              icon: "icon-phone.png",
              text: "직접 통화하기",
              class: "btn-icon-radius right shadow"
            }, null, 8, ["disabled"])
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_6,
          _createVNode(_component_autocall_button_off)
        ])
      ])
    ])
  ], 64))
}